import { createContext, useContext, useEffect, useState } from "react";
import { WHITELABELING_BRANDING_ENDPOINT } from "../config/urls";

const BrandingContext = createContext(null);

const BRANDING_CACHE_KEY = "bb_branding_cache";

try {
  const cached = localStorage.getItem(BRANDING_CACHE_KEY);
  const { favicon_url } = JSON.parse(cached) || {};
  if (favicon_url) {
    ["icon", "shortcut icon"].forEach((rel) => {
      const link = document.querySelector(`link[rel='${rel}']`) || document.head.appendChild(Object.assign(document.createElement("link"), { rel }));
      link.href = favicon_url;
    });
  }
} catch {}

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(() => {
    try {
      const cached = localStorage.getItem(BRANDING_CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    fetch(WHITELABELING_BRANDING_ENDPOINT)
      .then(res => res.json())
      .then(data => {
        setBranding(data);
        localStorage.setItem(BRANDING_CACHE_KEY, JSON.stringify(data));
      })
      .catch(() => {
      });
  }, []);

  useEffect(() => {
    const faviconUrl = branding?.favicon_url;
    if (!faviconUrl || typeof document === "undefined") return;

    const ensureFaviconLink = (relValue) => {
      let link = document.querySelector(`link[rel='${relValue}']`);
      if (!link) {
        link = document.createElement("link");
        link.rel = relValue;
        document.head.appendChild(link);
      }
      if (link.getAttribute("href") !== faviconUrl) {
        link.href = faviconUrl;
      }
      return link;
    };

    ensureFaviconLink("icon");
    ensureFaviconLink("shortcut icon");

    if (branding?.page_title) {
      document.title = branding.page_title;
    }
  }, [branding]);

  return (
    <BrandingContext.Provider value={branding ?? {}}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext) ?? {};